import React, { useEffect, useRef, useState } from 'react';

import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { useLocation } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";

import Section from '../Section'
import { getTikPikuahEshurim } from '../../server/ServerFunc';
import SvgIcon from '../../CustomeComponents/SvgIcon';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';
const PikuahInfo = ({ isSeparate }) => {
    const [eshurimList, setEshurimList] = useState([]);

    const search = useLocation().search;

    useEffect(() => {
		const tikNumURL = new URLSearchParams(search).get("TikNum");
		getEshurimContent(tikNumURL);	
	}, []);
    
    const getEshurimContent = async (tikNum) => {
        const eshurimData = await getTikPikuahEshurim(tikNum);
        if(eshurimData.length > 0) {
            // let myEshurimDataTest = [...eshurimData, {
            //     hitkableCode: 114000050, hitkableCodeText: "******", pikuahId: 107958, taarihKabalttofes: "22/08/1993", tikNum: "1992/0263.00", tofesCode: 47000050, tofesCodeText:  "בלה בלה בלה"
            // }, ...eshurimData];
            // setEshurimList(myEshurimDataTest);
            setEshurimList(eshurimData);
            const tikNumArr = eshurimData[0].tikNum.split("/");
            const numPart = tikNumArr[1].split('.');
            const tikStr = `${numPart[1]}_${numPart[0]}_${tikNumArr[0]}`;
            // setTikNumTitle(tikStr);
            // setTikNumTitle(tikNum);
        } else {
            setEshurimList([]);
            // setTikNumTitle("");
        }
    }

    const titles = {
        "tofesCodeText": "סוג טופס",
        "hitkableCodeText": "בוצע",
        "taarihKabalttofes": "תאריך קבלת טופס"
    }

    const exportPDF_NG = () => {
        const tikData = document.getElementById("tikToPrint");
        const pdf = new jsPDF("p", "mm");

        html2canvas(tikData).then((canvasTitle) => {
            console.log('canvasTitle', canvasTitle);
            const imgWidth = 190;
            const imgHeight = (canvasTitle.height * imgWidth) / canvasTitle.width;
            let positionY = 10;
            pdf.addImage(canvasTitle, "PNG", 10, positionY, imgWidth, imgHeight, "", "FAST");
        });

        //2. Save the table as pdf
        const data = document.getElementById("divToPrint");
        html2canvas(data).then((canvas) => {
            const imgWidth = 200; //180
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let positionY = 10;
            heightLeft -= pageHeight;

            pdf.addImage(canvas, "PNG", 0, positionY + 10, imgWidth, imgHeight, "", "FAST");
            while (heightLeft >= 0) {
                positionY = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(canvas, "PNG", 0, positionY + 20, imgWidth, imgHeight, "", "FAST");
                heightLeft -= pageHeight;
            }
            pdf.save(`אישורים בתיק פיקוח`);
        });
    }

    const LabeledDataItem = (label, value, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			<div className="value">{value}</div>
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

    const EshuimTikPikuahList = () => {
        return (
            <div id="divToPrint">
                <Grid data={eshurimList}>
                    <GridColumn field="tofesCodeText" title={titles.tofesCodeText} cell={LabeledCell} />
                    <GridColumn field="hitkableCodeText" title={titles.hitkableCodeText} cell={LabeledCell} />
                    <GridColumn field="taarihKabalttofes" title={titles.taarihKabalttofes} cell={LabeledCell} />
                </Grid>
            </div>
        )
    }

    return (
        <>
            { isSeparate && <AppHeaderGlobal /> }
            {
                <div className="container my-3 my-lg-5">
                    <span>
                        <SvgIcon icon={"download-doc"} title="ייצוא ל- PDF" onClick={() => exportPDF_NG()} style={{ cursor: "pointer", marginLeft: "5px" }} />
                        ייצוא ל- PDF
                    </span>
                    <Section icon={'folder-small'} title={'אישורים בתיק פיקוח'} className="mt-3">
                        {
                            eshurimList.length > 0 ?
                                <EshuimTikPikuahList />
                                :
                                <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
                        }
                    </Section>
                </div>

            }
            { isSeparate && <AppFooter /> }
        </>
    )
}

export default PikuahInfo;